export function constructUTCDate(date) {
  const [, year, month, day] = date.match(/([0-9]+)-([0-9]+)-([0-9]+)/);
  const offsetDate = new Date(Date.UTC(year, month - 1, day));
  return new Date(offsetDate.getTime() + offsetDate.getTimezoneOffset() * 60000);
}

export function getISODateString(date) {
  const [, day] = date.toISOString().match(/^(.+)T/);
  return day;
}

export function isDaylightSavingTime(date) {
  return new Date(date).toLocaleDateString(undefined, { timeZoneName: 'long' }).indexOf('Daylight') !== -1;
}

export function convertToCentralTime(date, time) {
  const [, hour, minute] = time.match(/([0-9]+):([0-9]+)/) || [];
  return `${parseInt(hour, 10) - (isDaylightSavingTime(date) ? 5 : 6)}:${minute}`;
}

export function convertToUTCTime(date, time) {
  const [, hour, minute] = time.match(/([0-9]+):([0-9]+)/) || [];
  return `${parseInt(hour, 10) + (isDaylightSavingTime(date) ? 5 : 6)}:${minute}`;
}

export function getMsCorrection(date) {
  return (isDaylightSavingTime(date) ? 5 : 6) * 3600 * 1000;
}

export function formatMSAsHHMMSS(ms) {
  return new Date(Math.max(ms, 0)).toISOString().substr(11, 8);
}

export function formatTimestampHHMMSS(dateOrValue) {
  const date = dateOrValue instanceof Date ? dateOrValue : new Date(dateOrValue);
  if (Number.isNaN(date.getTime())) return undefined;
  const hours = `${date.getHours()}`.padStart(2, '0');
  const minutes = `${date.getMinutes()}`.padStart(2, '0');
  const seconds = `${date.getSeconds()}`.padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

export function convertHHMMSStoMs(hhmmss) {
  const [, hour, minute, second] = hhmmss.match(/([0-9]+):([0-9]+):([0-9]+)/);
  return 1000 * (parseInt(second, 10) + 60 * parseInt(minute, 10) + 3600 * parseInt(hour, 10));
}

export function getAmPm(date) {
  return date.getHours() >= 12 ? 'pm' : 'am';
}

export function shiftDate(date, ampm) {
  if (ampm === 'am') {
    if (getAmPm(date) === 'am') {
      return date;
    }
    return new Date(date.setTime(date.getTime() + 12 * 60 * 60 * 1000)); // date + 12 hours
  }
  if (getAmPm(date) === 'pm') {
    return date;
  }
  return new Date(date.setTime(date.getTime() - 12 * 60 * 60 * 1000)); // date - 12 hours
}

export default {
  constructUTCDate,
  getISODateString,
  isDaylightSavingTime,
  convertToCentralTime,
  convertToUTCTime,
  getMsCorrection,
  formatMSAsHHMMSS,
  formatTimestampHHMMSS,
  convertHHMMSStoMs,
  getAmPm,
  shiftDate,
};
